"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
//
// components
//
const OnboardingHeader_1 = __importDefault(require("../OnboardingHeader"));
//
// styles
//
const StyledCard_1 = require("./StyledCard");
const StyledCardBody_1 = require("./StyledCardBody");
const StyledContainer_1 = require("./StyledContainer");
const StyledButton_1 = require("./StyledButton");
const StyledLinksContainer_1 = require("./StyledLinksContainer");
const StyledLinkContainer_1 = require("./StyledLinkContainer");
const StyledLinkText_1 = require("./StyledLinkText");
const StyledHyperlink_1 = require("./StyledHyperlink");
const StyledInvalidFeedback_1 = require("./StyledInvalidFeedback");
class OnboardingForm extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            passwordHidden: true
        };
        this.displayApiError = (error) => {
            if (error.message === 'Failed to fetch') {
                return 'The server could not be reached, please try again later';
            }
            if (error.message.includes('required')) {
                return 'All input is required, please try again';
            }
            if (error.message.includes('not_authenticated')) {
                return 'Please enter a valid email and password';
            }
            if (error.message) {
                return error.message;
            }
            return '';
        };
    }
    render() {
        return (react_1.default.createElement(StyledContainer_1.StyledContainer, { id: 'onboarding-form-container' },
            react_1.default.createElement(OnboardingHeader_1.default, { header: this.props.header }),
            react_1.default.createElement(StyledCard_1.StyledCard, { className: 'card' },
                react_1.default.createElement(StyledCardBody_1.StyledCardBody, { className: 'card-body' },
                    react_1.default.createElement("form", { onSubmit: this.props.onFormSubmit },
                        this.props.inputs,
                        this.props.cta ? (react_1.default.createElement(StyledButton_1.StyledButton, { className: 'btn btn-primary', disabled: this.props.loading, type: 'submit' }, this.props.loading ? 'Loading...' : this.props.cta)) : null),
                    this.props.apiError ? (react_1.default.createElement(StyledInvalidFeedback_1.StyledInvalidFeedback, { className: 'api-error invalid-feedback' }, this.displayApiError(this.props.apiError))) : null,
                    this.props.textPrompt ? (react_1.default.createElement(StyledLinksContainer_1.StyledLinksContainer, null,
                        react_1.default.createElement(StyledLinkText_1.StyledLinkText, { className: 'text-prompt' }, this.props.textPrompt))) : (
                    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
                    react_1.default.createElement(StyledLinksContainer_1.StyledLinksContainer, { spaced: this.props.resetPrompt },
                        react_1.default.createElement(StyledLinkContainer_1.StyledLinkContainer, null,
                            react_1.default.createElement(StyledLinkText_1.StyledLinkText, null, this.props.contactLink.preface),
                            react_1.default.createElement(StyledHyperlink_1.StyledHyperlink, { href: this.props.contactLink.href, rel: 'noreferrer', target: this.props.contactLink.href.includes('mailto')
                                    ? ''
                                    : '_self' }, this.props.contactLink.prompt)),
                        this.props.resetPrompt ? (react_1.default.createElement(StyledLinkContainer_1.StyledLinkContainer, null,
                            react_1.default.createElement(StyledHyperlink_1.StyledHyperlink, { href: this.props.resetPrompt.href, rel: 'noreferrer', target: '_self' }, this.props.resetPrompt.prompt))) : null))))));
    }
}
exports.default = OnboardingForm;
